// extracted by mini-css-extract-plugin
module.exports =  {"link":"NkqWxv","searchField":"vZhyN2","resultsTitle":"nt2YKB","defaultWeight":"p_FJqc"};